import { useEffect, useState } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import {
    Row,
    GRID_FIXED_MOBILE_PADDING,
    GRID_FIXED_PADDING
} from "../libraries/wpl/foundations/src";

export type GridOverlayFunction = () => void;
/**
 * @description Displays the responsive grid for development/design purposes.
 * Call toggleGrid() in the browser console to display/hide.
 * This component should only be rendered in non-production environments.
 * @returns
 */
export const GridOverlayWrapper = () => {
    // this grid is rendered client side only and should wait until after hydration
    const [hasHydrated, setHasHydrated] = useState<boolean>(false);
    const [shouldShowGrid, setShouldShowGrid] = useState<boolean>(false);

    useEffect(() => {
        setHasHydrated(true);
        setShouldShowGrid(
            !!window.localStorage.getItem("shouldShowGridOverlay")
        );
    }, []);

    if (typeof window !== "undefined") {
        window.toggleGrid = (): void => {
            if (!window.localStorage.getItem("shouldShowGridOverlay")) {
                window.localStorage.setItem("shouldShowGridOverlay", "true");
                setShouldShowGrid(true);
            } else {
                window.localStorage.removeItem("shouldShowGridOverlay");
                setShouldShowGrid(false);
            }
        };
    }

    return <>{hasHydrated && shouldShowGrid && <GridOverlay />}</>;
};

export const GridOverlay = () => {
    const gridOverlayStyle = css({
        "position": "fixed",
        "width": "100%",
        "insetInlineStart": "50%",
        "transform": "translateX(-50%)",
        "height": "100vh",
        "zIndex": 99999,
        "pointerEvents": "none",
        "backgroundColor": "rgb(from thistle r g b / .2)",

        ".row-layout": {
            background: "rgb(from deepskyblue r g b / .6)",
            opacity: ".2",
            backgroundClip: "padding-box",
            boxShadow: `inset ${GRID_FIXED_PADDING}px 0 0 rgb(from limegreen r g b / .4), inset -${GRID_FIXED_PADDING}px 0 0 rgb(from limegreen r g b / .4)`,

            [media.below.sm]: {
                boxShadow: `inset ${GRID_FIXED_MOBILE_PADDING}px 0 0 rgb(from limegreen r g b / .4), inset -${GRID_FIXED_MOBILE_PADDING}px 0 0 rgb(from limegreen r g b / .4)`
            }
        }
    });

    const columnStyle = css({
        background: "tomato",
        height: "100vh"
    });

    const columns = new Array(12)
        .fill("")
        .map((_, index) => <div css={columnStyle} key={`column-${index}`} />);

    return (
        <div css={gridOverlayStyle}>
            <Row layout="overlay">{columns}</Row>
        </div>
    );
};
